<template>
  <v-container id="project-overview" fluid tag="section" class="main-container">
    <v-row>
      <v-col cols="12" md="12">
        <idc-component-project-overview
          :settings="settings"
          :can-edit="false"
          :can-read="canRead"
          :can-delete="false"
          :status-type="status"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardProjectCancelledOverview',
    components: {
      IdcComponentProjectOverview: () => import('@/components/idc/projects/Overview'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
      status: () => ManagementStatus.STATUS_TYPE_CANCELLED,
    },
  })
</script>
